const TESTIMONIALS = [
  {
    quote: "We tried four different apps before DoorChart. Nothing else got the whole family to actually use it. The color-coded calendar alone was a game changer.",
    name: 'Sarah M.',
    role: 'Mom of three, Denver CO',
    color: '#f43f5e',
    initials: 'SM',
    stars: 5,
  },
  {
    quote: "Co-parenting across two homes was a scheduling nightmare. The linked households feature means my ex and I don't have to constantly text each other about the kids.",
    name: 'James K.',
    role: 'Co-parent, Austin TX',
    color: '#0ea5e9',
    initials: 'JK',
    stars: 5,
  },
  {
    quote: "The meal planning and auto-generated shopping list saves me at least an hour every week. I don't know how we managed without it.",
    name: 'Priya L.',
    role: 'Working parent, Seattle WA',
    color: '#10b981',
    initials: 'PL',
    stars: 5,
  },
  {
    quote: "My teenagers actually do their chores now because the stamp reward cards make it feel like a game. I'm not even joking.",
    name: 'Tom R.',
    role: 'Dad of two teens, Chicago IL',
    color: '#f59e0b',
    initials: 'TR',
    stars: 5,
  },
  {
    quote: "The vault feature alone is worth it. We have every Wi-Fi password, streaming account, and alarm code in one place. Finally.",
    name: 'Mei C.',
    role: 'Homeowner, San Francisco CA',
    color: '#8b5cf6',
    initials: 'MC',
    stars: 5,
  },
  {
    quote: "I set up DoorChart on a Sunday night and by Monday morning the whole family was using it. Setup was genuinely that simple.",
    name: 'Olivia W.',
    role: 'Stay-at-home parent, Nashville TN',
    color: '#ec4899',
    initials: 'OW',
    stars: 5,
  },
]

const Stars = ({ count }) => (
  <div className="flex gap-0.5 mb-3">
    {Array.from({ length: count }).map((_, i) => (
      <span key={i} className="text-amber-400 text-sm">★</span>
    ))}
  </div>
)

export const TestimonialsSection = () => (
  <section className="py-24 px-4">
    <div className="max-w-6xl mx-auto">
      <div className="text-center mb-14 reveal">
        <p className="text-primary text-sm font-semibold uppercase tracking-wider mb-3">Real families. Real results.</p>
        <h2 className="font-display text-3xl sm:text-4xl font-bold text-text-primary mb-4">
          Households love DoorChart
        </h2>
        <p className="text-text-secondary max-w-xl mx-auto">
          Don't take our word for it — here's what families actually say.
        </p>
      </div>

      <div className="columns-1 sm:columns-2 lg:columns-3 gap-5">
        {TESTIMONIALS.map(({ quote, name, role, color, initials, stars }, i) => (
          <div
            key={name}
            className="reveal break-inside-avoid mb-5 bg-white border border-border rounded-2xl p-6 shadow-sm"
            style={{ transitionDelay: `${i * 80}ms` }}
          >
            <Stars count={stars} />
            <p className="text-sm text-text-secondary leading-relaxed mb-5 italic">"{quote}"</p>
            <div className="flex items-center gap-3">
              <div
                className="w-9 h-9 rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0"
                style={{ backgroundColor: color }}
              >
                {initials}
              </div>
              <div>
                <div className="text-sm font-semibold text-text-primary">{name}</div>
                <div className="text-xs text-text-muted">{role}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
)
